import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption" }
const _hoisted_3 = { class: "_tc--light" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gfu-media _mt-2" }
const _hoisted_6 = { class: "_pos-r" }
const _hoisted_7 = {
  key: 0,
  class: "gfu-avatar--followed _flex _jc-c _ai-c _bgc--accent _tc--white"
}
const _hoisted_8 = { class: "_ml-2" }
const _hoisted_9 = { class: "_mb-1" }
const _hoisted_10 = {
  class: "gfu-hd gfu-hd--h4",
  "data-qa": "profile-comment:Nickname"
}
const _hoisted_11 = {
  class: "gfu-bt gfu-bt--caption _tc--light _ml-1",
  "data-qa": "profile-comment:Time"
}
const _hoisted_12 = { "data-qa": "profile-comment:Text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_user_follow = _resolveComponent("user-follow")
  const _component_base_avatar = _resolveComponent("base-avatar")

  return (_openBlock(), _createElementBlock("div", {
    class: "_pos-r",
    "data-qa": `project-comment-ID:${ $props.commentID }`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.Comments.CommentPreviewItemInLabel), 1 /* TEXT */),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("a", {
        href: $props.contextUrl,
        class: "_tc--accent",
        "data-qa": "profile-comment:RedirectLink"
      }, _toDisplayString($props.contextName), 9 /* TEXT, PROPS */, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_base_avatar, {
          "avatar-url": $props.avatarUrl,
          alt: $props.nickname,
          clean: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_user_follow, {
              nickname: $props.nickname,
              "user-url-name": $props.userUrlName,
              "user-id": $props.userId
            }, {
              default: _withCtx(({isFollowing}) => [
                isFollowing
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_base_icon, {
                        "icon-namespace": "ga",
                        name: "heart-solid-icon"
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["nickname", "user-url-name", "user-id"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["avatar-url", "alt"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString($props.nickname), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_11, _toDisplayString($options.timeDifferenceText), 1 /* TEXT */)
        ]),
        _createElementVNode("span", _hoisted_12, _toDisplayString($props.text), 1 /* TEXT */)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}